module.exports = __webpack_public_path__ + "static/img/be-evaluete-img.317c8554.png";